import React from "react";
import { Header } from "../../components/feature/Header";
import { Footer } from "../../components/feature/Footer";
import PageHero from "../../components/ui/PageHero";
import heroBureau from "../../assets/bureau-hero.jpg";
import { BureauMembers } from "./components/BureauMembers";

export default function BureauPage() {
  return (
    <>
      <Header />
      <PageHero
        src={heroBureau}
        title="Le Bureau"
        mode="contain-blur"
        heightClass="h-[44vh] md:h-[56vh]"
        focal="20% 20%"
        alt="CSVBV - Le Bureau"
      />
      <main className="py-12 bg-white">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <BureauMembers />
        </div>
      </main>
      <Footer />
    </>
  );
}
